import React from 'react';

const ChatAppContext = React.createContext({});

export default ChatAppContext;
